import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-gatorz-youtube.js';

const DEFAULT_VIDEO_URL = 'https://www.youtube.com/watch?v=HUdPr0x3Erg';

const html = `
<div class="gatorz-youtube-content" data-attribute="gatorz-youtube-content">
  <div class="gatorz-youtube__hero ImageHero" data-attribute="gatorz-youtube__hero">
    <iframe
      class="gatorz-youtube__iframe"
      data-attribute="gatorz-youtube__iframe"
      data-youtube-url="${DEFAULT_VIDEO_URL}"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </div>
</div>
`;

export default containerFuild(html, css, {
  topPadding: true,
  bottomPadding: false,
});
